import { ChangeDetectionStrategy, Component, signal, WritableSignal } from '@angular/core';
import { disabled, form, FormField, required } from '@angular/forms/signals';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { TIMEZONE_OPTIONS, TimezoneDto } from '@workspace/data-types';
import { AbstractSignalFormComponent } from '../../../../abstract';

@Component({
  selector: 'aura-internationalization-timezone-form',
  templateUrl: './internationalization-timezone-form.component.html',
  imports: [FormField, MatFormFieldModule, MatSelectModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuraInternationalizationTimezoneFormComponent extends AbstractSignalFormComponent<TimezoneDto> {
  override model: WritableSignal<TimezoneDto> = signal<TimezoneDto>({ timezone: 'Europe/Paris' });
  timezones = TIMEZONE_OPTIONS;

  override formTree = form(this.model, (b) => {
    required(b.timezone, { when: () => this.isRequired('timezone') });
    disabled(b.timezone, { when: () => this.allReadonly() || this.allDisable() });
  });
}
